document.querySelectorAll('.template-product [data-add-btn]').forEach(btn => {
  btn.addEventListener('click', (e) => {
    e.preventDefault();

    const target = document.querySelector('.product-info .product-info__block-item variant-picker');
    if (target) {
      const rect = target.getBoundingClientRect();
      const scrollY = window.scrollY || window.pageYOffset;
      const offset = 130;

      window.scrollTo({
        top: rect.top + scrollY - offset,
        behavior: 'smooth'
      });
    }
  });
});
